import { parseJsonSafely } from './jsonUtils';

export interface EmailLog {
    status: 'sucesso' | 'falha';
    detalhes?: string;
}

export const mapearEmail = (logs: any[]): EmailLog | null => {
    const logEmail = logs.find((log: any) => log.entidade_nome === 'email_flag');
    if (!logEmail) {
        return null;
    }
    const dadosExtra = parseJsonSafely(logEmail.dados_extra);
    const emailStatus = dadosExtra?.email_status || 'falha';
    if (emailStatus === 'profissional_nao_informado') {
        return null;
    }
    const email = dadosExtra?.email || null;
    const motivo = dadosExtra?.motivo || null;
    const erro = dadosExtra?.erro || null;
    const statusFinal: 'sucesso' | 'falha' = emailStatus === 'sucesso' ? 'sucesso' : 'falha';
    let detalhes = '';
    if (statusFinal === 'sucesso' && email) {
        detalhes = `Email enviado com sucesso para ${email}`;
    } else if (statusFinal === 'sucesso') {
        detalhes = motivo || 'Email enviado com sucesso';
    } else {
        detalhes = email
            ? `Erro ao enviar email para ${email}`
            : motivo || 'Erro ao enviar email';
        if (erro && !detalhes.includes(erro)) {
            detalhes += ` (${erro})`;
        }
    }
    return {
        status: statusFinal,
        detalhes: detalhes || undefined
    };
};
